export const authRoleAccess = {
    dashborad: ['Admin', 'user', 'Reporter', "Manager", 'Safety Manager'],
    all_incidents_view: ['Admin', 'Reporter', 'user', "Manager", 'Safety Manager'],
    my_assigned_tasks_view: ['Admin', 'Reporter', 'user', "Manager", 'Safety Manager'],

    //data setups
    incidet_type_setup: ['Admin', 'Safety Manager'],

    //user management
    profile: ['Admin', 'user', 'Reporter', 'Safety Manager'],
    //themeExamples: ['Admin', 'user', 'manager'],

    risk_assessment: ['Manager', 'Safety Manager'],
    user_management: ['Admin', 'Manager', 'Safety Manager'],

    company_profile: ['Admin','Safety Manager'],
    company_dataSetup: ['Admin','Safety Manager'],
    company_risk_assesment_dataSetup: ['Admin', 'Safety Manager'],

    audit_create: ['Safety Manager'],
    my_audits: ['Safety Manager', 'Manager', "User", "Reporter"],
    audit_answers_given: ['Safety Manager', 'Manager', "User", "Reporter"],

    trainingCategorySetup: ['Admin', 'Safety Manager'],
    trainingTeamSetup: ['Admin', 'Safety Manager'],
    trainingSetups: ['Admin', 'Safety Manager'],
}